var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'no-promo': !_vm.showPromo,
    'debug-screens': _vm.$store.getters.isLocalEnv,
    dunning: _vm.showDunningSnackbar,
    'promo-referral': _vm.showPromoReferral,
    'browse-page': _vm.isMarketplace,
    'promo-reactivation': _vm.hasReactivationPromo && _vm.isReactivationBarVisible,
    'holiday-promo': _vm.hasHolidayPromo,
  },attrs:{"id":"site-app"}},[_c('NavMenu'),_vm._v(" "),_c('div',{staticClass:"flex-1"},[_c('router-view')],1),_vm._v(" "),_c('MainFooter'),_vm._v(" "),(_vm.$store.state.openSignInModal)?_c('LoginModal',{attrs:{"social-error":_vm.socialError},on:{"trackLoginEvent":_vm.trackLoginEvent}}):_vm._e(),_vm._v(" "),(_vm.$store.state.openSignUpModal && !_vm.$store.getters.isLoggedIn)?_c('SignUpModal',{attrs:{"social-error":_vm.socialError}}):_vm._e(),_vm._v(" "),(_vm.showDunningPopup)?_c('DunningModal'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }